// This code is moved to snippet/tax-exempt.liquid Asset.
checkJquery(window.jQuery);

/**
 * Start of the script. It checks the JQuery.
 * @returns {*}
 */
function checkJquery($) {
    if ($) {
        window.jq = $;
        Jquery = window.jq;
        window.jq(document).ready(function () {
            const parent_width = Jquery('#taxExemptContainer').parent().width();
            if (parent_width < 400) {
                Jquery('.taxExemptInnerContainer').css('width', '100%');
            }
            getTaxExemptSettings(Jquery);
            return appStart(Jquery);
        });
    } else {
        loadScript('//ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js', function () {
            jQuery191 = jQuery.noConflict(true);
            checkJquery(jQuery191);
        });
    }
}




function loadScript(url, callback) {
    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState) {  //IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" ||
                script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others

        script.onload = function () {
            callback();
        };
    }


    script.src = url;

    document.getElementsByTagName("head")[0].insertBefore(script, document.getElementsByTagName("head")[0].childNodes[2]);

}

//This function is executing changeTaxExemptStatus as a promise so that the calling function could be chained easily.
function taxExemptPromise(event) {
    return new Promise((resolve, reject) => {
        // do something to process the answer
        resolve(changeTaxExemptStatus(event));
    });
}

//This function is executing taxExemptClickPromise as a promise so that the calling function could be chained easily.
function taxExemptClickPromise(event) {
    return Promise.all(
        [
            new Promise((resolve, reject) => {
                // do something to process the answer
                resolve(showIframe(event));
            })
            ,new Promise((resolve, reject) => {
            // do something to process the answer
            resolve(showCertificateField(event));
        })
        ]
    );
}


function getProfile(event,email){
    let localShop = location.origin;
    const action = 'action=get_customer_profile';
    let url = localShop + '/apps/tax-exempt-p/check-tax.php?' + action;
    return Jquery.ajax({
        url: url,
        type: "POST",
        data: {customer_email: email,shop: shop},
        beforeSend: function () {
        },
        complete: function () {

        },
        success: function (data) {
            if (data !== '') {
                let settings = JSON.parse(data);
                let profile_tax_exempted = settings.customer_tax_exempted;
                if(profile_tax_exempted==='yes'){
                    Jquery('#upload_tax_document').hide();
                    return false;
                }else{
                    Jquery('#upload_tax_document').show();
                    return true;
                }

            }
        }
    });
}

function getProfileCertificate(event,email){
    let localShop = location.origin;
    const action = 'action=get_customer_profile';
    let url = localShop + '/apps/tax-exempt-p/check-tax.php?' + action;
    return Jquery.ajax({
        url: url,
        type: "POST",
        data: {customer_email: email,shop: shop},
        beforeSend: function () {
        },
        complete: function () {

        },
        success: function (data) {
            if (data !== '') {
                let settings = JSON.parse(data);
                let profile_tax_exempted = settings.customer_tax_exempted;
                if(profile_tax_exempted==='yes'){
                    Jquery('#certificateFieldContainer').hide();
                    return false;
                }else{
                    Jquery('#certificateFieldContainer').show();
                    return true;
                }

            }
        }
    });
}

function appStart(Jquery) {
    Jquery = (Jquery !== undefined) ? Jquery : window.jq;
    var cartToken = fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
            const cartToken = data.token;
            Jquery('#taxExemptContainer #cart_token').attr('value',cartToken);
            return data.token
        });

    Jquery('#tax_exempt_on,#tax_exempt_off').click(function (event) {
        return taxExemptClickPromise(event)
    });
    let checkoutInput = Jquery('input[name=checkout]');
    let checkoutButton = Jquery('button[name=checkout]');
    let updateButton = Jquery('button[name=optionmustbeselectedbutton]');
    if (checkoutInput.length > 0) {
        window.ret = -1;
        checkoutInput.click( function(event){
            clickCheckout(event)
        });
    } else if (checkoutButton.length > 0) {
        window.ret = -1;
        checkoutButton.click( function(event){
            clickCheckout(event)
        });
    }

    if(updateButton.length >= 0){
        window.ret = -1;
        updateButton.click(
           function(event){
               clickCheckout(event)
           });
    }
    window.shop = (Shopify.shop !== undefined) ? Shopify.shop : window.Shopify.Checkout.apiHost;
}
function clickCheckout(event){
        // We need to check if iframe is already displayed or not
        // If iframe is already displayed and showIframe also results in showing iframe
        // then we will proceed to next step
        // If iframe is already displayed and showIframe is false then we will hide and also proceed to next step
        // If iframe is hidden before and show iframe is true only then we will return false.

        removeError(Jquery);
        removeIframeError(Jquery);
        removeErrorCertificate(Jquery);

        // get previous value of iframe
        let previousIframeValue = Jquery("#upload_tax_document").is(":hidden")
        let previousCertificateDisplay = Jquery("#certificateNumField").is(":hidden")

        showIframe(event).then( (result)=> {
            let futureIframeValue = Jquery("#upload_tax_document").is(":hidden")
            let stopExecutionIframe = false;
            let stopExecutionCertificate = false;

            if(previousIframeValue && !futureIframeValue){
                stopExecutionIframe = true;
            }
            showCertificateField(event).then( (result)=> {
                let futureCertificateDisplay = Jquery("#certificateNumField").is(":hidden");
                if(previousCertificateDisplay && !futureCertificateDisplay){
                    stopExecutionCertificate = true;
                }
                if(stopExecutionIframe||stopExecutionCertificate){
                    return false;
                } else{
                    return taxExemptPromise(event)
                }
            });
        });
        if (window.ret < 0) {
            return false;
        }
}

function changeTaxExemptStatus(event) {

    let Jquery = window.jq;
    if (window.ret < 0) {
        event.stopPropagation();
        captureTaxData(Jquery);
        event.preventDefault();
        return false;
    }
}

function showIframe(event) {

    let Jquery = window.jq;
    let iframeContainer =  Jquery('#upload_tax_document');
    let emailContainers = Jquery('#emailContainer');


    let tax_exempt_on = Jquery('#tax_exempt_on').is(':checked');
    let tax_exempt_off = Jquery('#tax_exempt_off').is(':checked');
    let show_tax_upload_form= Jquery("#upload_tax_document").attr("show-tax-form");
    let dont_show_tax_form = show_tax_upload_form==='no';
    let conditional_show_tax_form = show_tax_upload_form==='conditional';
    if(tax_exempt_off){
        removeIframeError(Jquery);
        iframeContainer.hide();
emailContainers.hide();
    }else if(tax_exempt_on) {
        if (dont_show_tax_form) {
            iframeContainer.hide();
        } else if(conditional_show_tax_form) {
            let email = Jquery('#taxExemptContainer #taxExemptEmail').val().trim();
            if(email){
                return getProfile(event, email);
            } else{
                iframeContainer.hide();
            }
        }else{
emailContainers.show();
            iframeContainer.show();
            return Promise.resolve(true);
var tabContent = document.querySelector('.tab-content');
tabContent.style.borderRadius = 'none';
tabContent.style.boxShadow = 'none';
        }
    }
    return Promise.resolve(false);
}



function showCertificateField(event) {

    let Jquery = window.jq;
    let certificateFieldSelector = Jquery('#certificateFieldContainer');

    let tax_exempt_on = Jquery('#tax_exempt_on').is(':checked');
    let tax_exempt_off = Jquery('#tax_exempt_off').is(':checked');

    let show_certificate_field = Jquery("#taxExemptContainer #certificateNumField").attr("data-show-tax-certificate-number")
    let dont_show_certificate_field = show_certificate_field==='no';
    let conditional_show_certificate_field = show_certificate_field==='conditional';


    if(tax_exempt_off){
        removeIframeError(Jquery);
        certificateFieldSelector.hide();
    }else if(tax_exempt_on) {
        if (dont_show_certificate_field) {
            certificateFieldSelector.hide();
        } else if(conditional_show_certificate_field) {
            let email = Jquery('#taxExemptContainer #taxExemptEmail').val().trim();
            if(email){
                return getProfileCertificate(event, email);
            } else{
                certificateFieldSelector.hide();
            }
        }else{
            certificateFieldSelector.show();
            return Promise.resolve(true);
        }
    }
    return Promise.resolve(false);
}

function taxExemptAjax(Jquery, email, tax_exempt_off, tax_exempt_on) {

    let show_certificate_field = Jquery("#certificateNumField").attr("data-show-tax-certificate-number");
    let optional_show_certificate_field = show_certificate_field==='optional';
    let dont_show_certificate_field = show_certificate_field==='no';
    let certificateValue = Jquery("#taxExemptContainer #certificateNumField").val().trim();
    let isCertificateHidden =  Jquery("#certificateNumField").is(":hidden");
    let alertMessageCertificate = Jquery("#certificateNumField").attr("data-alert-msg-certificate");
    let defaultAlertMessageCertificate = 'Enter your tax-exempt certificate number';


    if(alertMessageCertificate==null || alertMessageCertificate.trim().length<1){
        alertMessageCertificate = defaultAlertMessageCertificate;
    }


    //Now we will see the option accordingly
    // if the certificate value is empty and the value of it is not optional then we will
    // show the error else we will proceed as it is


    if((certificateValue==null || certificateValue.length < 1 ) && !isCertificateHidden && (!optional_show_certificate_field && !dont_show_certificate_field)){
        alert(alertMessageCertificate);
        setErrorCertificate(Jquery,alertMessageCertificate)
        return false;
    }
    if(certificateValue.length>1){
        const regex = new RegExp(/^[ A-Za-z0-9_@./#&+-]*$/);
        if(certificateValue.length>30){
            alert(alertMessageCertificate);
            setErrorCertificate(Jquery,'Error ! Field Exceeds max length')
            return false;
        }
        let testString = regex.test(certificateValue);
        if(!testString){
            alert(alertMessageCertificate);
            setErrorCertificate(Jquery,'Error ! Invalid Characters for the field')
            return false;
        }
    }


    let file_uploaded =  Jquery('#upload_tax_document').attr('file_uploaded')==='true';
    let alertMessage = Jquery("#upload_tax_document").attr("alert-msg");
    let IframeValue = Jquery("#upload_tax_document").is(":hidden");
    let show_tax_upload_form= Jquery("#upload_tax_document").attr("show-tax-form");
    let optional_show_tax_form = show_tax_upload_form==='optional'; //This means that even if the file is not uploaded we will proceed to next step
    let defaultAlertMessage = 'Upload tax-exempt supporting documents';



    //If validateTaxForm is true then it means file cannot be empty
    // So we will check if file is uploaded with file_upload and if file_uploaded is not true then we will give the alert

    if(alertMessage==null || alertMessage.trim().length<1){
        alertMessage = defaultAlertMessage;
    }
    if(!file_uploaded && !IframeValue && !optional_show_tax_form){
        setErrorIframe(Jquery, alertMessage);
        alert(alertMessage);
        return false;
    }

    var cartToken = fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => {
            const cartToken = data.token;
            return data.token
        });

    let shop = window.shop;
    let localShop = location.origin;
    let status = false;
    if (tax_exempt_on) {
        status = true
    }
    let exemptInfo = {
        'customer_email': email,
        'tax_exempt_off': tax_exempt_off,
        'tax_exempt_on': tax_exempt_on,
        'tax_exempt_email': window.settings.tax_exempt_email,
        'tax_exempt_option': window.settings.tax_exempt_option
    };

    let url = localShop + '/apps/tax-exempt-p/check-tax.php';
    cartToken.then((token) =>{
        Jquery.ajax({
            url: url,
            type: "POST",
            data: {
                cartToken: token,
                cust_email: email,
                certificateNumber:certificateValue,
                tax_exm: status,
                shop: shop
            },
            beforeSend: function () {
                // $('#loader').show();
                if (Jquery('button[name=checkout]').length > 0) {
                    Jquery('button[name=checkout]').text('Loading...')
                } else if (Jquery('input[name=checkout]').length > 0) {
                    Jquery('input[name=checkout]').val('Loading...')
                }
            },
            complete: function () {
                if (Jquery('button[name=checkout]').length > 0) {
                    Jquery('button[name=checkout]').text('Check Out')
                } else if (Jquery('input[name=checkout]').length > 0) {
                    Jquery('input[name=checkout]').val('Check Out')
                }
            },
            success: function (data) {
                if (data) {
                    const response = JSON.parse(data);
                    if (response.success) {

                        const cartForm = document.querySelector("[name=checkout][type=submit]").form;
                        let formAction = cartForm.getAttribute('action');
                        formAction += '?checkout[email]=' + email;
                        cartForm.setAttribute('action', formAction);

                        exemptInfo.is_new_customer = response.is_new_customer;
                        saveDataToBrowser({Jquery: Jquery, exemptInfo: exemptInfo});
                        removeError(Jquery);
                        return goForQuotes(Jquery);
                    } else if (response.email_error) {
                        setError(Jquery, 'Email is not valid.');
                    }
                }
            },
            error: function () {
                console.log("Error");
            }
        });
    });
    return false;
}

function captureTaxData(Jquery) {
    let tax_exempt_off = Jquery('#tax_exempt_off').is(':checked');
    let tax_exempt_on = Jquery('#tax_exempt_on').is(':checked');
    let email = Jquery('#taxExemptContainer #taxExemptEmail').val().trim();
    let always_require_email= Jquery("#taxExemptEmail").attr("data-require-email")
    let optional_require_email = always_require_email==='no';
    let option = false;
    option = tax_exempt_off || tax_exempt_on;
    if (!option && email.length < 1) {
        return goForQuotes(Jquery);
    } else if (!optional_require_email && option && email.length < 1) {
        setError(Jquery, 'Email is required.');
    } else if(optional_require_email && tax_exempt_on && email.length < 1){
        setError(Jquery, 'Email is required.');
    } else if (!option && email.length > 0) {
        if (!validateEmail(email)) {
            setError(Jquery, 'Email is not valid.');
        } else {
            setError(Jquery, 'Please choose one of the tax option.');
        }
    } else if (option && email.length > 0) {
        if (!validateEmail(email)) {
            setError(Jquery, 'Email is not valid.');
        } else {
            removeError(Jquery);
            return taxExemptAjax(Jquery, email, tax_exempt_off, tax_exempt_on);
        }
    }else if(tax_exempt_off && email.length < 1){
        removeError(Jquery);
        return goForQuotes(Jquery);
    }
}

/**
 * ---------------------------------------------------------------------------------------------------------------------
 * Validate the email.
 * ---------------------------------------------------------------------------------------------------------------------
 * This function will validate the email. This checks that the email is correctly entered.
 * @param email
 * @returns {boolean}
 */
function validateEmail(email) {
    let filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    return filter.test(email);
};

/**
 * Hide the popup and go for the quotes.
 * @param Jquery
 * @returns {boolean}
 */
function goForQuotes(Jquery) {
    window.ret = 1;
    document.querySelector("[name=checkout][type=submit]").click();
    return false;
}

function getTaxExemptSettings(Jquery) {
    const exemptInfo = JSON.parse(localStorage.getItem('exemptInfo'));
    if (exemptInfo !== null) {
        Jquery('#taxExemptEmail').val(exemptInfo.customer_email);
        const exemptOff = Jquery('#tax_exempt_off'),
            exemptOn = Jquery('#tax_exempt_on');
        if (exemptInfo.tax_exempt_off) {
            exemptOff.prop('checked', true);
            exemptOn.prop('checked', false);
        } else if (exemptInfo.tax_exempt_on) {
            exemptOn.prop('checked', true);
            exemptOff.prop('checked', false);
        }
    }

    let localShop = location.origin;
    const action = 'action=get_tax_exempt_settings';
    let url = localShop + '/apps/tax-exempt-p/check-tax.php?' + action;

    let iframeAction = 'action=upload_tax_documents';
    let iframeUrl = localShop + '/apps/tax-exempt-p/index.php?' + iframeAction;

    Jquery('#upload_tax_document').attr('src',iframeUrl)

    Jquery.ajax({
        url: url,
        type: "POST",
        beforeSend: function () {
        },
        complete: function () {

        },
        success: function (data) {
            if (data !== '') {
                let settings = JSON.parse(data);

                window.settings = {
                    tax_exempt_email: settings.tax_exempt_email,
                    tax_exempt_option: settings.tax_exempt_option
                };

                // Set labels
                setLabels(Jquery, settings);
            }

            // Enable the box on cart page.
            Jquery('#taxExemptContainer').fadeIn('slow', function () {
                Jquery('#taxExemptContainer').css('display', 'flex');
            });


        }
    });
    return false;
}

/**
 * Set the label according to settings.
 * @param Jquery
 * @param settings
 */
function setLabels(Jquery, settings) {
    const tax_exempt_status = settings['tax_exempt_status'] !== '' ? settings['tax_exempt_status'] : 'Tax Exempt Status';
    const sales_tax_label = settings['sales_tax_label'] !== '' ? settings['sales_tax_label'] : 'My organization is not tax exempt';
    const cust_tax_exempt_label = settings['cust_tax_exempt_label'] !== '' ? settings['cust_tax_exempt_label'] : 'My organization is tax exempt';
    const email_preface_text = settings['email_preface_text'] !== '' ? atob(settings['email_preface_text']) : 'Enter the email address to use for this order.';
    const certificate_no_preface_text = settings['certificate_no_preface_text'] !== '' ? atob(settings['certificate_no_preface_text']) : 'Enter the tax-exempt certificate number.';
    const tax_border_color = settings['tax_border_color'] !== '' ? '#' + settings['tax_border_color'] : '#ffffff';
    const email_placeholder = settings['email_placeholder'] !== '' ? settings['email_placeholder'] : 'Enter email..';
    const certificate_no_placeholder = settings['certificate_no_placeholder'] !== '' ? settings['certificate_no_placeholder'] : 'Enter certificate num..';
    const tax_border_width = settings['tax_border_width'] !== '' ? settings['tax_border_width'] : '1.5px';
    const always_require_email = settings['always_require_email'];

    const show_tax_upload_form = settings['show_tax_document_form'];
    let alert_msg_tax_validation = settings['alert_msg_tax_validation'];

    const alert_msg_certificate_validation = settings['alert_msg_certificate_validation'];
    let show_certificate_number_field = settings['show_certificate_number_field'];

    Jquery("#taxExemptEmail").attr("data-require-email", always_require_email);
    Jquery("#certificateNumField").attr("data-alert-msg-certificate", alert_msg_certificate_validation);
    Jquery("#certificateNumField").attr("data-show-tax-certificate-number", show_certificate_number_field);
    Jquery("#upload_tax_document").attr("show-tax-form", show_tax_upload_form);
    Jquery("#upload_tax_document").attr("alert-msg", alert_msg_tax_validation);
    Jquery("#tax_exempt_status").text(tax_exempt_status);
    Jquery("#sales_tax_label").text(sales_tax_label);
    Jquery("#cust_tax_exempt_label").text(cust_tax_exempt_label);
    Jquery("#email_preface_text").html(email_preface_text).text();
    Jquery("#taxExemptEmail").attr("placeholder", email_placeholder);
    Jquery("#certificate_number_preface_text").html(certificate_no_preface_text).text();
    Jquery("#certificateNumField").attr("placeholder", certificate_no_placeholder);
    Jquery(".taxExemptInnerContainer").css('border', tax_border_width + 'px solid ' + tax_border_color);
    Jquery('#cart_token').css(
        {
            'display':'none',
        }
    );
    Jquery('#certificateFieldContainer').css(
        {
            'display':'none',
        }
    );
    Jquery('#upload_tax_document').css(
        {
            'height':'13em',
            'width':'100%',
            'border':tax_border_width + 'px solid ' + tax_border_color,
            'box-shadow':'0 0 0 1px rgba(63, 63, 68, .05), 0 1px 3px 0 rgba(63, 63, 68, .15)'
        }
    );

    showIframe(event);
    showCertificateField();
}

function setErrorIframe(Jquery, msg) {
    let iframe_container = Jquery('#upload_tax_document');
    Jquery(iframe_container).find(".error").remove(); // Remove the previous error if there is any.
    Jquery(iframe_container).css('border', '1px solid #cc0000');
    Jquery(iframe_container).after('<p style="color: red;margin-bottom:0;" class="error">' + msg + '</p>');
    let tax_container = Jquery('#taxExemptContainer');
    Jquery(tax_container).find(".error").remove(); // Remove the previous error if there is any.
    //Jquery(tax_container).find("#taxExemptEmail").css('border', '1px solid #cc0000');
    Jquery(tax_container).find("#upload_tax_document").before('<p style="color: red;margin-bottom:0;" class="error">' + msg + '</p>');

}
function removeIframeError(Jquery) {
    let tax_container = Jquery('#taxExemptContainer');
    let iframe_container = Jquery('#upload_tax_document');

    Jquery(iframe_container).find(".error").remove();
    Jquery(tax_container).find(".error").remove();
    Jquery(iframe_container).css('border', '1px solid #95a7b7');
}

function setErrorCertificate(Jquery, msg) {
    let certificate_container = Jquery('#taxExemptContainer');
    Jquery(certificate_container).find(".error").remove(); // Remove the previous error if there is any.
    Jquery(certificate_container).find("#certificateNumField").css('border', '1px solid #cc0000');
    Jquery(certificate_container).find("#certificateNumField").after('<p style="color: red;margin-bottom:0;" class="error">' + msg + '</p>');
}
function removeErrorCertificate(Jquery) {
    let certificate_container = Jquery('#taxExemptContainer');
    Jquery(certificate_container).find(".error").remove();
    Jquery(certificate_container).find("#certificateNumField").css('border', '1px solid #95a7b7');
}

function setError(Jquery, msg) {
    let tax_container = Jquery('#taxExemptContainer');
    Jquery(tax_container).find(".error").remove(); // Remove the previous error if there is any.
    Jquery(tax_container).find("#taxExemptEmail").css('border', '1px solid #cc0000');
    Jquery(tax_container).find("#taxExemptEmail").after('<p style="color: red;margin-bottom:0;" class="error">' + msg + '</p>');
}

function removeError(Jquery) {
    let tax_container = Jquery('#taxExemptContainer');
    Jquery(tax_container).find(".error").remove();
    Jquery(tax_container).find("#taxExemptEmail").css('border', '1px solid #95a7b7');
}

function saveDataToBrowser(parameters) {
    console.log(parameters);
    let {Jquery, exemptInfo} = parameters;
    localStorage.removeItem('exemptInfo');
    localStorage.setItem('exemptInfo', JSON.stringify(exemptInfo));
}